/** Intake / Profile your AI — Figma-aligned tokens */
export const INTAKE_COLORS = {
  bg: "#F5F5F5",
  surface: "#FFFFFF",
  border: "#E6E6E6",
  grey20: "#E6E6E6",
  grey10: "#F5F5F5",
  primary: "#005BF0",
  primary20: "#F0F6FF",
  primary30: "#BDD6FF",
  primary40: "#3895FF",
  primaryDark: "#0046B8",
  text: "#383838",
  textMuted: "#707070",
  textSecondary: "#555555",
  white: "#ffffff",
  black: "#1a1a1a",
  g1: "#f7f7f7",
  g2: "#E6E6E6",
  g3: "#d0d0d0",
  g4: "#999999",
  g5: "#666666",
  blue: "#005BF0",
  blueLight: "#F0F6FF",
  blueDark: "#0046B8",
  green: "#1FAC6E",
  greenLight: "#D7E5DE",
  greenDark: "#197F5C",
  amber: "#E4A11A",
  amberLight: "#FFE999",
  amberBadge: "#FEF3C7",
  amberBadgeText: "#B45309",
  red: "#D6441F",
  redLight: "#fee2e2",
  purple: "#9551EC",
  purpleLight: "#F3E8FF",
  purpleBanner: "#EDE9FE",
  orange: "#ea580c",
  orangeLight: "#fff7ed",
  doc: "#0046B8",
  chat: "#3895FF",
  inferred: "#9551EC",
  pending: "#707070",
  sectionActive: "#FFF6E0",
  sectionActiveRing: "#E4A11A",
  success60: "#00754E",
  warning60: "#8A5C00",
  grey60: "#555555",
  successBadgeBg: "#E8F5EF",
  warningBadgeBg: "#FFF6E0",
  greyBadgeBg: "#F5F5F5",
  progressGreen: "#14B871",
  progressTrack: "linear-gradient(90deg, rgba(0, 0, 0, 0.08) 0%, rgba(255, 255, 255, 0.16) 100%)",
};

export const INTAKE_FONT = "'Sora', 'Lato', sans-serif";
export const INTAKE_MONO = "'JetBrains Mono', monospace";
